<!-- /src/components/common/Modal/ContentModal.vue -->
<template>
  <transition name="modal">
    <div class="modal">
      <div class="modal--container">
        <div class="modal--content--container">
          <h2>{{ title }}</h2>
          <div class="modal--content" v-html="content"></div>
          <div class="modal--close" @click="closeModal">
            <i class="icon fas fa-times-circle"></i>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'modal',

  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
  },

  data() {
    return {}
  },

  computed: {},

  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
  },

  components: {},
}
</script>

<style scoped>
.modal {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 47, 108, 0.6);
  position: fixed;
  z-index: 200;
  display: grid;
  transition: opacity 0.3s ease;

  &--container {
    position: relative;
    /* align-self: center;
        justify-self: center; */
    background-color: var(--lightGray);
    max-width: 60vw;
    padding: 2rem;
    border-radius: 0.5rem 0 0.5rem 0.5rem;
    pointer-events: none !important;
    transition: all 0.3s ease;
  }

  &--close {
    position: absolute;
    left: 100%;
    background-color: var(--lightGray);
    border-radius: 0 0.5rem 0.5rem 0;
    top: 0;
    padding: 0.5rem;
    font-size: 1rem;
    cursor: pointer;
  }

  &--content {
    overflow: auto;
    &--container {
      max-height: 80vh;
      overflow: hidden;
    }
  }
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal--container,
.modal-leave-active .modal--container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
